import SectionHeading from '@/components/base/SectionHeading';
import Reveal from '@/components/base/Reveal';
import { roadmap } from '@/mocks/smart-farm';

export default function Roadmap() {
  return (
    <section className="w-full px-4 md:px-6 py-16 md:py-24 bg-background-50">
      <div className="max-w-5xl mx-auto">
        <SectionHeading
          eyebrow="建设路径"
          title="分阶段建设 快速形成成果"
          subtitle="遵循「先基础、后业务、再运营」的实施逻辑，逐步完成数字化升级。"
        />

        <Reveal className="mt-12">
          <div className="relative">
            {/* 纵向连接线 */}
            <div className="absolute left-5 top-0 bottom-0 w-px bg-foreground-200 hidden md:block"></div>

            <div className="flex flex-col gap-6">
              {roadmap.map((step) => (
                <div key={step.no} className="relative flex gap-5 md:gap-8">
                  <div className="relative z-10 hidden md:flex flex-col items-center shrink-0">
                    <div className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-500 text-foreground-950 font-bold text-sm">
                      {step.no}
                    </div>
                  </div>
                  <div className="flex-1 p-5 md:p-6 rounded-lg bg-background-50 border border-background-200">
                    <div className="flex items-center gap-2">
                      <span className="w-6 h-6 flex items-center justify-center rounded-full bg-accent-500 text-foreground-950 text-xs font-bold md:hidden">
                        {step.no}
                      </span>
                      <span className="text-xs font-semibold text-accent-700 bg-accent-100 px-2.5 py-0.5 rounded-full whitespace-nowrap">
                        {step.phase}
                      </span>
                    </div>
                    <h3 className="mt-3 font-heading font-bold text-foreground-950 text-xl">
                      {step.title}
                    </h3>
                    <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{step.content}</p>
                    <div className="mt-3 flex items-start gap-2">
                      <i className="ri-check-double-line text-accent-600 mt-0.5"></i>
                      <span className="text-sm text-foreground-800 whitespace-normal">
                        <span className="font-medium">阶段成果：</span>
                        {step.result}
                      </span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}